import { useState } from 'react';

export const useExamModals = () => {
	const [openExamModal, setOpenExamModal] = useState(false);
	const [openResultModal, setOpenResultModal] = useState(false);

	return {
		openExamModal,
		setOpenExamModal,
		openResultModal,
		setOpenResultModal
	};
};
